import { createApp } from "vue";
import { createAxios } from "@/utils/axios";
import { createPinia } from "pinia";
// import './style.css'
import App from "./App.vue";
import router from "./routes";
import "./style.css";
import "./style/main.scss";
import { userAuthStore } from "./store/auth";
import { getUserData } from "./api/user";

const pinna = createPinia();
const app = createApp(App);
app.use(pinna);
app.use(router);
const axios = createAxios();
app.provide("request", axios);

app.mount("#app");

const common = userAuthStore();

if (common.authToken === null || common.currUserData === null) {
  router.beforeEach(async (to, from, next) => {
    console.log("main.ts beforeEach", common.currUserData, common.authToken);
    const queryParams = to.query;
    if (queryParams && queryParams?.token) {
      common.authToken = queryParams.token;
    }
    if (queryParams && queryParams?.platform) {
      common.platform = queryParams.platform;
    }
    if (common.currUserData === null) {
      await getUserData().then((res: any) => {
        common.currUserData = res;
      });
    }

    next();
  });
}
// router.beforeEach(async (to, from, next) => {
//   const queryParams = to.query;
//   const store = userAuthStore();
//   if (queryParams && queryParams?.token && store.currUserData === null) {
//     store.currUserData = await store.getUserData();
//     console.log(store.currUserData);
//   }
//   // console.log("beforeEach----------", JSON.stringify(queryParams));
//   // console.log(`Navigating from ${from.fullPath} to ${to.fullPath}`);
//   next();
// });
